import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import EventSectionS2 from '../../components/EventSectionS2/EventSectionS2';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';

const EventPageS2 = () => {
    const { t } = useTranslation('events');
    return (
        <Fragment>
            <Navbar />
            <PageTitle pageTitle={t('pageTitle')} pagesub={t('pageTitle')} />
            <EventSectionS2 showPast />
            <Footer ftClass={'s2'}/>
            <Scrollbar />
        </Fragment>
    )
};
export default EventPageS2;
